import {
  Button, Flex, FormControl, FormLabel, Input, Modal,
  ModalBody, ModalCloseButton, ModalContent, ModalFooter,
  ModalHeader, ModalOverlay, Select, Text, useDisclosure
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { UserDataV2 } from "@/models";
import { useUsers } from "../../hooks"
import { showToast } from "@/utils/toast";
import { EditIcon2 } from "@/styles/icons";
import { UserPermissionsInfo } from "./_user_perm_info";
interface AdicionarUsuarioProps {
  user?: UserDataV2;
}




export function EditarUsuario({ user }: AdicionarUsuarioProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const [editUser, setEditUser] = useState<UserDataV2>();
  const { updateUser, getListProfiles, getUser } = useUsers()
  const [profile, setProfile] = useState<string>("");
  const [status, setStatus] = useState<string>();
  const [profiles, setProfiles] = useState<{ label: string; value: string }[]>([]);

  async function getProfileData() {
    try {
      const response = await getListProfiles()
      setProfiles(response)
    } catch (error) {
      return error
    }
  }


  async function getDetailsUser(user) {
    try {
      const response = await getUser(user.id)
      setProfile(response.data.profile)
      setStatus(response.data.status)
      setEditUser(response.data)
    } catch (error) {
      return error
    }
  }

  async function updateUsers(user, data) {
    try {
      const response = await updateUser(user.id, data)
      setEditUser(response.data)
      
      showToast({
        type: "success",
        message: "Usuario Atualizado com sucesso.",
      });
    } catch (error) {
      showToast({
        type: "error",
        message: "Erro ao atualizar o usuario.",
      });
      return error
    } finally {
      onClose()
    }
  }


  useEffect(() => {
    if (isOpen && user) {
      async function fetchData() {
        await getDetailsUser(user);
      }
      getProfileData()
      fetchData();
    }
  }, [isOpen, user])




  const handleSave = () => {

    const newUser: Partial<UserDataV2> = {
      profile: profile,
      status: status,
    };
    updateUsers(editUser, newUser)

  };

  return (
    <>

      {

        <Flex
          gap="4"
          fontSize="14px"
          p="0 5px"
          w="100%"
          cursor="pointer"
          onClick={onOpen}
          alignContent="center"
          alignItems="center"
        >
          <EditIcon2 />
          <Text>Editar Usuario</Text>
        </Flex>


      }

      <Modal initialFocusRef={initialRef} finalFocusRef={finalRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            color="black"
          >Editar Usuário</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>


              <FormLabel
                mt={4}
                fontSize="12px"
              >Email</FormLabel>
              <Input
                isDisabled={true}
                ref={initialRef}
                placeholder="Email"
                value={editUser?.email}
              />
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Perfis</FormLabel>


              <Select
                onChange={(e) => {
                  setProfile(e.target.value)
                }}

                value={profile || ""}
              >
                <option value="" disabled>Selecione um perfil</option>
                {profiles?.map((item: any) => (
                  <option key={item.value} value={item.value}>

                    {item.label}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Status</FormLabel>
              <Select
                onChange={(e) => {
                  setStatus(e.target.value)
                }}
                value={status || ""}
              >
                <option value="ACTIVE" >ATIVO</option>
                <option value="BLOCKED" >BLOQUEADO</option>
                <option value="INACTIVE" >INATIVO</option>
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter
            display="flex"
            gap="8px"
          >
            <Button 
              size="sm"
              variant="ghost2"
              borderRadius="8px"
              onClick={onClose}
              _hover={{
                bgColor: "black",
                color: "white",
              }}
            >
              Cancelar
            </Button>
            <Button 
              size="sm"
              variant="ghost2"
              borderRadius="8px"
              onClick={handleSave}
              _hover={{
                bgColor: "black",
                color: "white",
              }}
            >
              Salvar
            </Button>
            
          </ModalFooter>
          <UserPermissionsInfo selectedProfile={profile} />
        </ModalContent>
      </Modal>
    </>
  );
}
